import React from "react";
import { NakiNigunArtistAlbumLoaderTemplate } from "themes/administration/naki-nigun/components";

const NakiNigunArtistAlbumLoader = (props) => {
    return <NakiNigunArtistAlbumLoaderTemplate {...props} />;
};

export default NakiNigunArtistAlbumLoader;
